// extracted by mini-css-extract-plugin
export default {"payersLayout":"PayersLayout_payersLayout__S1LVP"};